import React from 'react'
import {
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { ColorPicker, Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreatePopupForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
        initialValues={{
          stylesheet: [
            { type: 'btn' },
            { type: 'text' },
            { type: 'hover' },
            { type: 'background' },
          ],
        }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Novo Tema
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor do botão contendo o link do popup `}
                  </Typography>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Cor do botão"
                        source="stylesheet[0].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor do texto do botão `}
                  </Typography>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Cor do texto do botão"
                        source="stylesheet[1].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor do hover do botão `}
                  </Typography>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Cor do hover do botão"
                        source="stylesheet[2].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor do fundo`}
                  </Typography>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Cor do fundo"
                        source="stylesheet[3].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
